!(function() {
	const selects = document.getElementsByTagName("SELECT");

	for (let i = 0; i < selects.length; i++) {
		selects[i].addEventListener("change", function() {

			if ( this.options[0].selected ) {
				this.classList.add("text-secondary-400");
			}
			else {
				this.classList.remove("text-secondary-400");
			}
		});
	}
})();